export type FormProps = {
  formData: mumms.CPPEntity;
};

export const TreatmentSchedule = 'Treatment Schedule';
export const Other = 'Other';
export const Bereavement = 'Bereavement';
export const AdditionalAssistance = 'Additional Assistance';
// drawmode indicate if horizontal drawing
export const horizontal = 'horizontal';

// todo in common utils
// PLANS control types
export const label = 'label';
export const input = 'input';
export const radio = 'radio';
export const singleselect = 'singleselect';
export const multiselect = 'multiselect';
export const checkbox = 'checkbox';
export const goals = 'goals';

/**
-> drawmode: 'horizontal' => isHorizontalMode should be for input/singleselect/multiselect
-> readonlydrawmode is for the goals section
-> nooutcome is for Goal questions where there is a "who" but not an "outcome". Outcome is the "Goal will be achieved within" question
-> overwritedrawmode is for single and multi select
*/
